module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.191d0058.svg";